<template>
	<div id="research-phase-pie" style="width: 100%;height: 100%;">

	</div>
</template>

<script>
	export default {
		props:{
			data:{
				type:Array,
				default(){
					return []
				}
			},
			
		},
		watch:{
			data:{
				handler(val){
				let newData = val.map(item=>{
					if (item.typeName!=='已结题') {
						return {
							name:item.typeName,
							value:item.totalNumber,
						}
					}
				})
				this.$nextTick(()=>{
					this.initPie(newData)
				})
			},
				immediate: true
			}
		},
		methods: {
			initPie(data) {
				let echarts = this.$echarts.init(document.getElementById('research-phase-pie'));
				
				let option = {
				    // title: {
				    //     text: '某站点用户访问来源',
				    //     subtext: '纯属虚构',
				    //     left: 'center'
				    // },
				    tooltip: {
				        trigger: 'item',
				        formatter: '{a} <br/>{b} : {c} ({d}%)'
				    },
				    // legend: {
				    //     orient: 'vertical',
				    //     left: 'left',
				    //     data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
				    // },
				    series: [
				        {
				            name: '访问来源',
				            type: 'pie',
				            radius: '55%',
				            center: ['50%', '50%'],
										label: {
											formatter: '{b}:{c}\n({d}%)'
										},
				            data: data,
				            emphasis: {
				                itemStyle: {
				                    shadowBlur: 10,
				                    shadowOffsetX: 0,
				                    shadowColor: 'rgba(0, 0, 0, 0.5)'
				                }
				            }
				        }
				    ]
				};
		
			
				echarts.setOption(option);
			},
		},
	}
</script>

<style scoped>

</style>